import { PodiumElement } from "@podium/element";
import { styles } from "./global.js";

export default class WarpElement extends PodiumElement {
  static styles = [styles];
}
